import React from 'react';
import { Box } from '@mui/material';
import type { SxProps, Theme } from '@mui/material';

export interface ContentDatelineProps {
  /** Content with various date fields (createdAt/updatedAt, snake_case variants). */
  content: {
    createdAt?: string;
    created_at?: string;
    updatedAt?: string;
    updated_at?: string;
  };
  /** Which date to show. `auto` (default) shows updatedAt if present, else createdAt. */
  field?: 'createdAt' | 'updatedAt' | 'auto';
  /** Optional sx overrides. */
  sx?: SxProps<Theme>;
}

const formatDate = (dateString?: string): string => {
  if (!dateString) return '';
  try {
    return new Date(dateString).toLocaleDateString();
  } catch {
    return '';
  }
};

export const ContentDateline: React.FC<ContentDatelineProps> = ({ content, field = 'auto', sx }) => {
  const created = content.createdAt ?? content.created_at;
  const updated = content.updatedAt ?? content.updated_at;
  const dateString = field === 'createdAt' ? created : field === 'updatedAt' ? updated : (updated ?? created);
  const formatted = formatDate(dateString);
  if (!formatted) return null;
  return (
    <Box
      component="span"
      sx={[{ whiteSpace: 'nowrap', flexShrink: 0 }, ...(Array.isArray(sx) ? sx : sx ? [sx] : [])]}
    >
      {formatted}
    </Box>
  );
};

export default ContentDateline;
